
import Vue from 'vue'
import Router from 'vue-router'
import p404 from '@/pages/404'
import home from '@/pages/home'
import product from '@/pages/product'
import industry from '@/pages/industry'
import partner from '@/pages/partner'
import about from '@/pages/about'
import contact from '@/pages/contact'

Vue.use(Router)

let router = new Router({
	mode: 'history',
  routes: [
    {
      path: '/',
      name : 'home',
      component: home,
      meta: {
        title:'header.home'
      }
    },
    {
      path: '/products',
      name: 'product',
      component: product,
      meta:{
        title:'EachCloud|产品介绍',
        keywords:['Salesforce','供应链管理', '订单系统', '校友平台', '微信小程序', 'CRM', 'Windows桌面应用', '高山书院', 'NielsCloud', '亿企云产品介绍'],
        description: "亿企云科技的产品介绍页面，提供详细的产品信息和解决方案。亿企云基于现代企业数字化需求，提供极具竞争力的云计算产品和服务"
      }
    },
    {
      path: '/solutions',
      name: 'industry',
      component: industry,
      meta:{
        title:'EachCloud|定制服务',
        keywords:['亿企云', '定制服务', '云服务', 'IT咨询', 'Salesforce咨询', '云原生', '开发和培训服务'],
        description: "亿企云提供多种定制服务，充分满足全球大中小型客户的个性化需求。亿企云透过行业深度见解和高可靠服务，助您的成功一臂之力！"
      }
    },
    {
      path: '/partner',
      name: 'partner',
      component: partner,
      meta:{
        title:'EachCloud|合作伙伴',
        keywords:['亿企云', '合作伙伴', '宽岳', 'SGS', '美丽中国', '亿企云服务全球客户'],
        description: "亿企云认真聆听、收集并积极响应合作伙伴的需求，建立以合作伙伴为中心的交付框架。"
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta:{
        title:'EachCloud|公司介绍',
        keywords:['国家科技型中小企业', 'IT专家', 'MBA', '业务驱动', '敏捷', '精益'],
        description: "亿企云是国家科技型中小企业，专注研发和服务全球客户。我们的使命是让亿万企业上云，用科技赋能企业发展"
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact,
      meta:{
        title:'EachCloud|联系我们',
        keywords:['亿企云地址', '亿企云联系方式', '亿企云邮件地址', '亿企云联系表单'],
        description: "亿企云全称为成都亿企云科技有限公司，位于中国成都市高新区天府五街。也可以通过邮件和这个页面的在线表单联系我们。"
      }
    },
    {
      path: '*',
      name: '404',
      component: p404
    }
  ]
})

router.afterEach((to, from) => {
  // _czc.push(["_trackPageview", to.path, from.path])
  // _czc.push(["_trackEvent", "导航栏", "点击",to.meta.title])
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js